import React ,{useEffect} from "react";
import * as Yup from "yup";
import {useDispatch , useSelector} from "react-redux";
import {useNavigate , Link} from "react-router-dom";
import { useFormik } from "formik";
import { registerUserAction } from "../redux/slices/userSlices";
import "../styles/register.css"
import Message from "./Message";


const formSchema = Yup.object({
    email : Yup.string().required("Email is required"),
    password : Yup.string().required("password is required"),
    name : Yup.string().required("name is required"),
    collegename : Yup.string().required("surname is required"),
});

export default function Register(){
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const formik = useFormik({
        initialValues : {
            email : "",
            password : "",
            name : "",
            collegename : "",
        },

        onSubmit : (values)=>{
            dispatch(registerUserAction(values));
        },

        validationSchema :  formSchema,

    });

    const storeData = useSelector((store)=>store?.users);
    
    const {user,prevLink} = storeData;

    useEffect(()=>{
        if(user){
            navigate(prevLink);
        }
    },[user,navigate,prevLink,dispatch])
    
    
    return (
        <>
        <Message/>
    <div id="main">
        <div className="sign-in-container">
            <form className="sign-in-form" onSubmit={formik.handleSubmit}>
                <div className="form-header">Start for free</div>
                <div className="form-title">Create new Account! </div>
                <div className="form-footer">Already a member? <Link to="/login">Log In</Link></div>
                <div className="name-inputs">
                    <label for="first-name" className="input-label">First Name</label>
                    <input type="text" id="first-name" className="input-value" value={formik.values.name} onChange={formik.handleChange("name")} placeholder="Enter your first name"  required/>
                </div>

                <div className="name-inputs">
                    <label for="college-name" className="input-label">College Name</label>
                    <select
                        type="text"
                        id="college-name"
                        className="input-value"
                        value={formik.values.collegename}
                        onChange={formik.handleChange("collegename")}
                        placeholder="Enter your college name"
                        required
                  >
                    <option value="" disabled>Select your college</option>
                    <option value="Viit">Viit</option>
                    <option value="Vit">Vit</option>
                    <option value="Pict">Pict</option>
                    <option value="Coep">Coep</option>
                    <option value="JSPM">JSPM</option>
                    <option value="BVP">BVP</option>
                  </select>
                </div>

                <div className="email-group">
                    <label for="email" className="input-label">Email</label>
                    <input type="email" id="email" className="input-value" value={formik.values.email} onChange={formik.handleChange("email")} placeholder="Enter your email" required/>
                </div>

                <div className="password-group">
                    <label for="password" className="input-label">Password</label>
                    <input type="password" id="password" className="input-value" value={formik.values.password} onChange={formik.handleChange("password")} placeholder="Enter your password" required/>
                </div>

                <div className="form-actions">
                    <button type="submit" className="create-account-btn">Create Account</button>
                </div>
                
            </form>
        </div>
    </div>
    </>

    )
}
